import auth, { IChangePassword } from '../services/auth';
import routing from '../services/routing';
import queryString from '../services/queryString';
import signOut from './signOut';
import redirect from './redirect';

export default async (formData: IChangePassword) => {
    const params = queryString.parse(routing.location.search);
    await auth.changePassword(formData);
    // when a logout uri is specified use it instead of signout
    if (params.logoutUri) {
        redirect({ redirect_uri: params.logoutUri });
    } else {
        signOut();
    }
};
